import { FC } from 'react'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import Button from 'components/parts/button/button'

import { IObj } from 'constants/types/common.types'
import { cutHashFromURL } from 'utils/getURLData'

interface IButtonToPayment {
  PaymentData?: IObj<string | number>
  wrapperModificator?: string
  buttonModificator?: string
  isButtonDisabled?: boolean
  text: string
  paymentHandler?: any
}

const ButtonToPayment: FC<IButtonToPayment> = ({
  PaymentData,
  paymentHandler,
  wrapperModificator,
  buttonModificator,
  text,
  isButtonDisabled,
}) => {
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)

  const defaultPaymentHandler = () => {
    setTimeout(
      () =>
        router.push(
          {
            pathname: '/process',
            query: { ...PaymentData, path, paymentService: 'alfa' },
          },
          '/process'
        ),
      500
    )
  }

  return (
    <div className={clsx(wrapperModificator)}>
      <Button
        disabled={isButtonDisabled}
        onClick={paymentHandler ? paymentHandler : defaultPaymentHandler}
        modificator={buttonModificator}
      >
        {text}
      </Button>
    </div>
  )
}

export default ButtonToPayment
